export default function generateSrcSet(images) {
    return images.map(x => `${x.url} ${x.scale}x`).join(", ");
}
